

//  Immediately Invoked Function Expression to keep the javascript Scope contained
(function() {
    angular
        .module('app')
        .factory('localization', localization);

    localization.$inject = ['$cookies', '$state', '$translate', '$http'];

    // This directive makes the model of the file marked for upload accessible
    function localization($cookies, $state, $translate, $http) {
        var vm = this;
        var now = new Date();
        vm.setLanguage = setLanguage;
        vm.setLocation = setLocation;
        vm.getLocation = getLocation;
        vm.getLanguage = getLanguage;
        vm.getCurrency = getCurrency;
        vm.currencyFromCountry = currencyFromCountry;
        vm.getLocationIso = getLocationIso;

        function setLocation(location) {
            vm.location = location;
            var expiration = new Date(now.getFullYear(), now.getMonth()+1, now.getDate());
            $cookies.put('selected_location', vm.location, {expires: expiration, path: '/'});
            $state.current.params.location = vm.location;
            $state.params.location = vm.location;
            if($state.current.name.length > 0) {
                return $state.go($state.current.name,$state.params,  {
                    location: true,
                    inherit: true,
                    relative: $state.$current,
                    reload: false,
                    notify: false
                });
            }
        }

        function getLocation() {
            if(!vm.location && $cookies.get('selected_location')) {
                vm.location = $cookies.get('selected_location');
                return new Promise((resolve, reject) => {resolve($cookies.get('selected_location'));});
            } else if(!vm.location && !$cookies.get('selected_location') && !vm.IPInfo) {
                return getIPInfo().then(function() {
                    vm.location = vm.IPInfo.country_name;
                    $cookies.put('selected_location', vm.location, {expires: new Date(now.getFullYear(), now.getMonth()+1, now.getDate()), path: '/'});
                    return vm.location;
                }).catch(function() {
                    vm.location = "Denmark";
                    $cookies.put('selected_location', vm.location, {expires: new Date(now.getFullYear(), now.getMonth()+1, now.getDate()), path: '/'});
                    return vm.location;
                })
            } else if(!vm.location && !$cookies.get('selected_location') && vm.IPInfo) {
                vm.location = vm.IPInfo.country_name;
                $cookies.put('selected_location', vm.location, {expires: new Date(now.getFullYear(), now.getMonth()+1, now.getDate()), path: '/'});
                return new Promise((resolve, reject) => {resolve(vm.location);});
            } else if(vm.location) {
                return new Promise((resolve, reject) => {resolve(vm.location);});
            }
        }

        function setLanguage(language, noReload) {
            vm.language = language;
            var expiration = new Date(now.getFullYear(), now.getMonth()+1, now.getDate());
            $lang = language.replace(/\_.{2,2}$/, '');
            $cookies.put('selected_language', language, {expires: expiration, path: '/'});
            $state.current.params.language = $lang;
            $state.params.language = $lang;
            $translate.use(language.substr(0,2));

            if($state.current.name.length > 0 && !noReload) {
                return $state.go($state.current.name,$state.params,  {
                    location: true,
                    inherit: true,
                    relative: $state.$current,
                    reload: false,
                    notify: false
                });
            }

        }

        function getLanguage() {
            return vm.language;
        }

        function getCurrency() {
            return currencyFromCountry(getLocationIso());
        }

        function currencyFromCountry(country) {
            switch (country) {
                case "DK":
                    return "dkk";
                case "SE":
                    return "sek";
                case "DE":
                case "ES":
                    return "eur";
                default:
                    return "dkk";
            }
        }

        function getLocationIso(location) {
            switch (location ? location : vm.location) {
                case "Denmark":
                    return "DK";
                case "Sweden":
                    return "SE";
                default:
                    return "DK";
            }
        }

        function languageFromCountry(country) {
            switch (country) {
                case "Denmark":
                    return "da_dk";
                case "Sweden":
                    return "sv";
                default:
                    return "en_us";
            }
        }

        function countryMapping(country) {

        }

        function getIPInfo() {
            vm.IPInfo = null;
            return $http.get("api/user/country").then(function (response)
            {
                vm.IPInfo = response.data;
                if(vm.IPInfo.country_name != "Denmark" && vm.IPInfo.country_name != "Sweden" ) {
                    vm.IPInfo.country_name = "Denmark";
                }
            });
        }

        return vm;
    }
})();
